import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  content: {
    margin: `${theme.spacing(3)}px ${-theme.spacing(1)}px`,
  },
  boldHelperText: {
    fontSize: 14,
    color: '#072D83',
  },
}));
